import type { ProductDto } from "../types/validation";

export function productImageUrl(id: string, explicit?: string): string {
	return explicit ?? `/img/p/200/${id}.jpg`;
}

export function getProductsCacheKey(products: ProductDto[]): string {
	return products
		.map((p) => p.id)
		.sort()
		.join("|");
}
